import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'components/atoms/Button/IconButton';
import LeftSettingMenu from 'components/molecules/LeftSettingMenu';
import SideMenu from 'components/molecules/SideMenu';
import { isActiveSettingMenu, isActiveSideMenu, disableAllMenu, isActiveQuickMenu, isActiveExpandImageModal, isActiveInitialModal , isActiveExitModal} from 'modules/actions/statusMenu';
import { useDispatch, useSelector } from 'react-redux';
/**
 * Chatting:Header
 */
const ChatHeader = ({ title, viewType }) => {
  const settingMenuStatus = useSelector(state => state.isActive.settingMenu);
  const sideMenuStatus = useSelector(state => state.isActive.sideMenu);
  const quickMenuStatus = useSelector(state => state.isActive.quickMenu);
  const expandImageModalStatus = useSelector(state => state.isActive.expandImageModal);
  const initialModalStatus = useSelector(state => state.isActive.initialModal);
  const exitModalStatus = useSelector(state => state.isActive.exitModal);

  const dispatch = useDispatch();

  const onClickOut = () => {
    dispatch(disableAllMenu());
  };
  /* 셋팅매뉴 클릭시 다른 메뉴창 닫힘 */
  const onSettingMenu = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    if (quickMenuStatus) {
      dispatch(isActiveQuickMenu());
    }
    if (expandImageModalStatus) {
      dispatch(isActiveExpandImageModal());
    }
    dispatch(isActiveSettingMenu());
  };  

  /* 사이드메뉴 클릭시 다른 메뉴창 닫힘 */
  const onSideMenu = () => {
    if (settingMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    if (quickMenuStatus) {
      dispatch(isActiveQuickMenu());
    }
    if (expandImageModalStatus) {
      dispatch(isActiveExpandImageModal());
    }
    dispatch(isActiveSideMenu());
  };
  const onInitialModal = () => {
     dispatch(isActiveInitialModal());
  }

  const onExitModal = () => {
    dispatch(isActiveExitModal());
 }
  const reLoad = () => {
    window.location.reload();
  };
  
  return (
    <header className="_chat_header">
      <div className="_left_div">
      <button type='button'
          className={sideMenuStatus ? 'menu-trigger active-7' : 'menu-trigger type7'}
          onClick={() => {
            onSideMenu();
          }}
          aria-label="퀵메뉴"
          title="퀵메뉴"
        >
          <span />
          <span />
          <span />
        </button>
        <IconButton
          icon="ri-settings-3-line round"
          styleDef={{
            borderRadius: '0px',
            color: '#FFF',
            // transform: settingMenuStatus ? 'rotate(180deg)' : 'rotate(0deg)',
            // opacity: settingMenuStatus ? '1' : '0.5',
            opacity: '1',
            // transition: settingMenuStatus ? '0.5s' : '0.5s',
            strokeWidth: '40px',
            left: '40px'
          }}
          propName='set'
          viewStatus=""
          clickEvt={onSettingMenu}
        />
      </div>
      <div className="_center_div">
        <div className="_title" onClick={onInitialModal} aria-label='소송절차 안내봇'>
          <h1>소송절차 안내봇</h1>
        </div>
      </div>
      <div className="_right_div">
        <IconButton
          icon="ri-restart-line"
          styleDef={{ borderRadius: '40px', border: '0px', color: '#FFF', fontSize: '25px', position: 'fixed', top: '10px', right: '45px' }}
          propName='restart'
          viewStatus=""
          clickEvt={onInitialModal}
        />
        <button type='button' className='_header_close' onClick={onExitModal} aria-label='챗봇종료' title="챗봇종료">
        <img src={`${process.env.PUBLIC_URL}/images/svg/chatHeaderClose.svg`} alt='챗봇종료버튼' aria-hidden='true' style={{width: '20px', marginTop:'3px'}}/>
        </button>
        {/* <IconButton icon="ri-menu-fill" styleDef={{ borderRadius: '0px', color: '#FFF' }} viewStatus="" clickEvt={onSideMenu} /> */}
      </div>

      <div className="setting" style={{ display: settingMenuStatus || sideMenuStatus || quickMenuStatus ? 'block' : 'none' }} onClick={() => onClickOut()} />

      <LeftSettingMenu styleDef={{ height: settingMenuStatus ? '150px' : '0px' }} />

      <SideMenu styleDef={{ width: sideMenuStatus ? '250px' : '0px' ,display: sideMenuStatus ? '':'none' }} />
      {/* <SideMenu styleDef={{ display: sideMenuStatus ? 'block' : 'none' }} /> */}
    </header>
  );
};

ChatHeader.propTypes = {
  title: PropTypes.string,
  viewType: PropTypes.string,
};
ChatHeader.defaultProps = {
  title: '',
  viewType: '',
};
export default ChatHeader;
